import { Link } from 'react-router-dom'
import './BackButton.css'

// Единая кнопка «Назад» для всех экранов: квадратная, со стрелкой, слева от заголовка.
export default function BackButton({ to, onClick, label = 'Назад' }) {
    const icon = <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" aria-hidden="true"><path d="M15 6l-6 6l6 6" /></svg>
    return to
        ? <Link className="back-button" to={to} aria-label={label} title={label}>{icon}</Link>
        : <button type="button" className="back-button" onClick={onClick} aria-label={label} title={label}>{icon}</button>
}
